export default {
  title: {
    en: 'YOUR SUBSRIPTION WAS PAUSED!',
  },
  firstName: {
    en: `Hi {firstName},<br />`,
  },
  text: {
    en: `
    You may have noticed that your Scentbird fragrance didn’t arrive on your doorstep this month.<br/>
    It looks like we had some trouble delivering it because of the wrong shipping address.<br/>
    Let’s fix this together - it should take no longer than 30 seconds to update your shipping address.<br/>
    <br/>
    Our birdie looks forward to delivering your next scent!<br/>
  `,
  },
  button: {
    en: 'UPDATE SHIPPING INFORMATION',
  },
  contactInfo: {
    en: `
    If you have any questions, please contact us at:<br />
    support@scentbird.com
  `,
  },
}
